module.exports = __webpack_public_path__ + "img/gold-nugget.0a320b8e.png";